import React, {useRef, useState} from "react"
import {DefaultTablePagination, Popconfirm, Table, Tooltip} from "../../../components/Elements/appUtils"
import {patientSaleFxn} from "../actions/patients";
import {customAxios as axios, getToken} from "../../../request";
import {getProductReport} from "../../purchase/api";
import moment from "moment";


const PatientSaleList = (props) => {
    let tableRef = useRef()
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [saleDetails, setSaleDetails] = useState({});
    const [loadingDetails, setLoadingDetails] = useState({});

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.customerId = props.customerId;
            params.sortField = "_id"
            params.sortOrder = "descend"
            let resp = await patientSaleFxn(params);
            resolve(resp)
        })
    }

    const fetchSaleDetails = async (saleId) => {
        if (!saleId || saleDetails[saleId]) {
            return
        }

        setLoadingDetails(prev => ({...prev, [saleId]: true}))
        try {
            let config = {
                params: {salesId: saleId},
                ...(await getToken()),
            };
            const response = await axios.get(getProductReport(), config);

            setSaleDetails(prev => ({...prev, [saleId]: response.data?.data || []}))
        } catch (error) {
            console.error("Error fetching sale details for", saleId, error)
            setSaleDetails(prev => ({...prev, [saleId]: []}))
        } finally {
            setLoadingDetails(prev => ({...prev, [saleId]: false}))
        }
    }

    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
            width: 60,
        },
        {
            title: "Invoice No",
            dataIndex: "invoiceNumber",
            key: "invoiceNumber",
            width: 60,
        },
        {
            title: "Vendor",
            dataIndex: "customerId",
            key: "customerId",
            width: 120,
            render: (text, record) => <span>{text?.name}</span>,
        },
        {
            title: "Mobile",
            dataIndex: "customerId",
            key: "customerId",
            width: 100,
            render: (text) => <span>{text?.mobile}</span>,
        },
        {
            title: "Invoice Number",
            dataIndex: "invoiceNumber",
            key: "invoiceNumber",
            width: 80,
        },
        {
            title: "Sale Category",
            dataIndex: "saleCategoryName",
            key: "orderId",
            width: 100,
        },
        {
            title: "Order Id",
            dataIndex: "orderId",
            key: "saleCategoryName",
            width: 80,
        },
        {
            title: "Sales Date",
            dataIndex: "salesDate",
            key: "salesDate",
            render: (text) => <span>{moment(text).format("DD-MMM-YY, hh:mm A")}</span>,
            width: 125,
        },
        {
            title: "State",
            dataIndex: "customerId",
            key: "customerId",
            render: (text) => <span>{text?.state}</span>,
            width: 140,
        },
        {
            title: "Total Qty",
            dataIndex: "quantity",
            key: "quantity",
            width: 46,
        },
        {
            title: "Net Amount",
            dataIndex: "finalAmount",
            key: "finalAmount",
            width: 80,
            render: (text) => <span>Rs. {text}</span>,
        },

        {
            title: "Received Amount",
            dataIndex: "paidAmount",
            key: "paidAmount",
            width: 80,
            render: (text) => <span>Rs. {text}</span>,
        },

        {
            title: "Order Status",
            dataIndex: "orderStatus",
            width: 80,
            key: "orderStatus",
        },
        {
            title: "Tracking Id",
            dataIndex: "trackingDetails",
            width: 80,
            key: "trackingDetails",
        },
        {
            title: "Payment Status",
            dataIndex: "paymentStatus",
            width: 80,
            key: "paymentStatus",
        }
    ];


    const expandedRowRender = (record) => {
        const saleId = record._id;
        const details = saleDetails[saleId] || [];
        const loading = loadingDetails[saleId];

        if (loading) {
            return <div style={{padding: 16}}>Loading sale details...</div>
        }

        if (!details.length) {
            return <div style={{padding: 16}}>No sale details found.</div>
        }


        return (
            <div style={{padding: 16, overflowX: 'auto'}}>
                <table className="table table-bordered table-xs mb-0">
                    <thead>
                    <tr>
                        <td>Sr no.</td>
                        <td>Product Name</td>
                        <td>Report Type</td>
                        <td>Mfg Date</td>
                        <td>Exp Date</td>
                        <td>Batch</td>
                        <td>Qty.</td>
                        <td>Sale Price</td>
                        <td>Price</td>
                        <td>Dis Amt.</td>
                        <td>Taxable Amt.</td>
                        <td>CGST Amt.</td>
                        <td>SGST Amt.</td>
                        <td>Net Amt.</td>
                    </tr>
                    </thead>
                    <tbody>
                    {details.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.productName}</td>
                            <td>{item.reportType}</td>
                            <td>{item.manufacturingDate}</td>
                            <td>{item.expiryDate}</td>
                            <td>{item.batchNo}</td>
                            <td>{item.quantity}</td>
                            <td>Rs. {item.salePrice}</td>
                            <td>Rs. {item.price}</td>
                            <td>
                                Rs. {item.discountAmount} (
                                {item.discount}%)
                            </td>
                            <td>Rs. {item.taxableAmount}</td>
                            <td>Rs. {item.cgstAmount}</td>
                            <td>Rs. {item.sgstAmount}</td>
                            <td>Rs. {item.netAmount}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    };
    return (
        <div>
            <Table
                apiRequest={apiRequest}
                columns={columns}
                ref={tableRef}
                position={"top"}
                expandable={{
                    expandedRowKeys,
                    onExpandedRowsChange: (keys) => {
                        setExpandedRowKeys(keys || []);
                        if (keys && keys.length) {
                            keys.forEach((key) => fetchSaleDetails(key));
                        }
                    },
                    expandedRowRender: expandedRowRender,
                }}
                pagination={{...DefaultTablePagination(), defaultPageSize: 50}}

            />
        </div>
    )
}
export default PatientSaleList